import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { dispatch } from "../../../../../reduxReducers/configureStore";
import { setAuthData } from "../../../../../reduxReducers/slices/AuthSLice";

const PersonalDetailsForm = () => {
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Phone Number is required"),
  });

  const user = useSelector((state) => state.Auth.authData);

  const updateUser = useCallback(
    async (values, setSubmitting) => {
      try {
        const response = await axios.put(`/users/${user._id}`, {
          first_name: values.firstName,
          last_name: values.lastName,
          phone: values.phone,
        });
        if (response.data) {
          dispatch(setAuthData(response.data));
        }
      } catch (error) {
      } finally {
        setSubmitting(false);
      }
    },
    [user._id]
  );

  return (
    <div className="p-4">
      <h2 className="font-[600] mb-2">Personal Details</h2>
      <p className="text-slate-500 mb-2">
        Update your personal information below.
      </p>
      <Formik
        initialValues={{
          firstName: user?.first_name ?? "",
          lastName: user?.last_name ?? "",
          email: user?.email ?? "",
          phone: user?.phone ?? "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          updateUser(values, setSubmitting);
        }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-700"
              >
                First Name
              </label>
              <Field
                type="text"
                id="firstName"
                name="firstName"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 bg-transparent rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="John"
              />
              <ErrorMessage
                name="firstName"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div>
              <label
                htmlFor="lastName"
                className="block text-sm font-medium text-gray-700"
              >
                Last Name
              </label>
              <Field
                type="text"
                id="lastName"
                name="lastName"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 bg-transparent rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Doe"
              />
              <ErrorMessage
                name="lastName"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <Field
                type="email"
                id="email"
                name="email"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 bg-transparent rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="johndoe@example.com"
                disabled
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                Phone Number
              </label>
              <Field
                type="text"
                id="phone"
                name="phone"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 bg-transparent rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="+1 (555) 123-4567"
              />
              <ErrorMessage
                name="phone"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <div className="mt-6">
              <button
                type="submit"
                className="px-6 py-2 bg-slate-600 text-white rounded-md shadow-md hover:bg-slate-700"
              >
                Save Changes
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default PersonalDetailsForm;
